import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PhitoDateAdapter extends NativeDateAdapter {
    getFirstDayOfWeek(): number {
        return 1;
    }

    parse(value: any): Date {
        if (value && typeof value == 'string') {
            let dateString: string = value;
            if (dateString.includes('.')) {
                const dateParts: string[] = dateString.split('.');
                if (dateParts.length === 2) {
                    let d = new Date();
                    // d.setDate(Number.parseInt(dateParts[0]));
                    d.setMonth(Number.parseInt(dateParts[1]) - 1, Number.parseInt(dateParts[0]));
                    return d;
                } else if (dateParts.length === 3) {
                    let d = new Date();
                    // d.setDate(Number.parseInt(dateParts[0]));
                    d.setMonth(Number.parseInt(dateParts[1]) - 1, Number.parseInt(dateParts[0]));
                    const yearString = dateParts[2];
                    if (yearString.length === 2) {
                        const yearNumber = Number.parseInt(yearString);
                        d.setFullYear(2000 + yearNumber);
                    } else if (yearString.length === 4) {
                        d.setFullYear(Number.parseInt(yearString));
                    }
                    return d;
                }
            } else {
                //ddMMYYYY
                if (dateString.length === 8) {
                    console.log('datestring: %s', dateString);
                    const d = dateString.substr(0, 2);
                    console.log('d: %s', d);
                    const m = dateString.substr(2, 2);
                    const y = dateString.substr(4, 4);
                    let date = new Date();
                    // date.setDate(Number.parseInt(d));
                    date.setMonth(Number.parseInt(m) - 1, Number.parseInt(d));
                    date.setFullYear(Number.parseInt(y));
                    console.log('ddMMYYYY: %s', date);
                    return date;
                }
                //ddMMYY
                else if (dateString.length === 6) {
                    const d = dateString.substr(0, 2);
                    const m = dateString.substr(2, 2);
                    const y = dateString.substr(4, 4);
                    let date = new Date();
                    // date.setDate(Number.parseInt(d));
                    date.setMonth(Number.parseInt(m) - 1, Number.parseInt(d));
                    date.setFullYear(2000 + Number.parseInt(y));
                    return date;
                }
            }
        }
    }

    format(date: Date, displayFormat: Object): string {
        let day: string = date.getDate().toString();
        day = +day < 10 ? '0' + day : day;
        let month: string = (date.getMonth() + 1).toString();
        month = +month < 10 ? '0' + month : month;
        let year = date.getFullYear();
        return `${day}.${month}.${year}`;
    }
}

export const PHITO_DATE_FORMATS = {
    parse: { dateInput: 'dd.MM.YYYY' },
    display: {
        dateInput: 'dd.MM.YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'MMM YYYY',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
